import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { usePublicAuth } from '../../context/PublicAuthContext';
import PublicLayout from '../../layouts/PublicLayout';
import { API_BASE_URL } from '../../config';

const MagicLinkCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');
    const { loginClient } = usePublicAuth();
    const [status, setStatus] = useState('Verificando link de acesso...');
    const verificationAttempted = React.useRef(false);

    useEffect(() => {
        if (!token) {
            setStatus('Link inválido (token ausente).');
            return;
        }

        if (verificationAttempted.current) return;
        verificationAttempted.current = true;

        const verifyToken = async () => {
            try {
                setStatus('Autenticando...');
                const response = await axios.post(`${API_BASE_URL}/api/public/auth/verify-token/`, { token });
                const { access_token, client } = response.data;

                loginClient(access_token, client);
                setStatus('Login realizado com sucesso! Redirecionando...');

                setTimeout(() => {
                    navigate('/public/profile');
                }, 1000);
            } catch (error) {
                console.error(error);
                // If the error is 400 but we already have a token locally (rare race condition handling), maybe ignoring is safer?
                // But for now, the ref check should prevent the second call entirely.
                setStatus('Erro ao verificar o link. Ele pode ter expirado ou já ter sido usado.');
            }
        };

        verifyToken();
    }, [token, navigate, loginClient]);

    return (
        <PublicLayout>
            <div className="container mt-5 text-center">
                <div className="card p-5 shadow-sm">
                    <h3>{status}</h3>
                    <div className="mt-3">
                        {status.includes('Erro') && (
                            <button className="btn btn-primary" onClick={() => navigate('/public/menu')}>
                                Voltar ao Menu
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </PublicLayout>
    );
};

export default MagicLinkCallback;
